import { ProjectSectionHeader } from '@/components/projects'
import { Button } from '@/components/ui/button'
import { AddIcon } from '@/components/icons'
import { useAuth } from '@/hooks'
import { Permissions } from '@/lib/permissions'

interface AgentsHeaderProps {
  projectId: string
  onCreateAgent: () => void
}

export function AgentsHeader({ projectId, onCreateAgent }: AgentsHeaderProps) {
  const { hasPermission } = useAuth(projectId)

  return (
    <ProjectSectionHeader sectionName="Agents">
      {hasPermission(Permissions.Project.Agent.Create, projectId) && (
        <Button onClick={onCreateAgent}>
          <AddIcon />
          New Agent
        </Button>
      )}
    </ProjectSectionHeader>
  )
}
